import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import AddressServiceV2 from '../../services/v2/AddressServiceV2';

const addressServiceV2 = AddressServiceV2();

export const REACT_QUERY_GET_ADDRESSES_V2_QUERY_KEY = 'getAddressesV2';
export const REACT_QUERY_GET_ADDRESS_V2_QUERY_KEY = 'getAddressV2';

const QUERY_KEY_ADDRESSES = [REACT_QUERY_GET_ADDRESSES_V2_QUERY_KEY];

export const useGetAddressesV2 = (options = {}) => {
  const query = useQuery({
    queryKey: QUERY_KEY_ADDRESSES,
    queryFn: () => addressServiceV2.getAddresses(),
    ...options,
  });

  return {
    ...query,
    data: query.data || {},
  };
};

export const useGetAddressV2ById = (id, options = {}) => {
  const query = useQuery({
    queryKey: [REACT_QUERY_GET_ADDRESS_V2_QUERY_KEY, id],
    queryFn: () => addressServiceV2.getAddressById(id),
    enabled: !!id,
    ...options,
  });

  return {
    ...query,
    data: query.data || {},
  };
};

export const useCreateAddressV2 = (options = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: addressServiceV2.createAddress,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEY_ADDRESSES });
    },
    ...options,
  });
};

export const useUpdateAddressV2 = (options = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: addressServiceV2.updateAddress,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEY_ADDRESSES });
    },
    ...options,
  });
};

export const useDeleteAddressV2 = (options = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: addressServiceV2.deleteAddress,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEY_ADDRESSES });
    },
    ...options,
  });
};

export const useSetDefaultAddressV2 = (options = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id) => addressServiceV2.updateAddress({ id, isDefault: true }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEY_ADDRESSES });
    },
    ...options,
  });
};
